import {Injectable} from '@angular/core';
import HealthApi from 'src/app/domain/service/api/health.api';
import {isOnMaintenance} from 'src/app/domain/model/health/health.model';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceStatusService {
  private isUnderMaintenanceSubject = new BehaviorSubject<boolean>(false);
  private lastCheckTime = 0;
  private readonly checkIntervalMs = 30000;

  constructor(private healthApi: HealthApi) {
  }

  public async checkMaintenanceStatus(): Promise<boolean> {
    try {
      const health = await this.healthApi.fetch();
      const maintenance = isOnMaintenance(health);
      this.isUnderMaintenanceSubject.next(maintenance);
      this.lastCheckTime = Date.now();
      return maintenance;
    } catch (error) {
      this.isUnderMaintenanceSubject.next(false);
      return false;
    }
  }

  public async checkMaintenanceStatusIfNeeded(): Promise<boolean> {
    const now = Date.now();
    const timeSinceLastCheck = now - this.lastCheckTime;

    if (timeSinceLastCheck > this.checkIntervalMs) {
      return await this.checkMaintenanceStatus();
    }

    return this.isUnderMaintenanceSubject.value;
  }

  public isUnderMaintenance$(): Observable<boolean> {
    return this.isUnderMaintenanceSubject.asObservable();
  }

  public isUnderMaintenanceSync(): boolean {
    return this.isUnderMaintenanceSubject.value;
  }
}
